{
  "fields": {
    "category": {
      "label": "Category",
      "placeholder": "Search by catégory"
    },
    "type": {
      "label": "Type",
      "placeholder": "Search by type"
    },
    "health_type": {
      "label": "Health professional type",
      "placeholder": "Search by health professional"
    },
    "name": {
      "label": "Lastname / Firstname / Legal title",
      "placeholder": "Search by last/first-name/legal title"
    },
    "submission_regime": {
      "label": "Submission regime",
      "placeholder": "Search by submission regime"
    },
    "pack": {
      "label": "Advantages pack",
      "placeholder": "Search by advantages pack"
    },
    "created_by": {
      "label": "Added by",
      "placeholder": "Search by added by"
    },
    "ticket_badge": {
      "label": "Workflow step :",
      "placeholder": "Step",
      "CREATING": "Creating",
      "TO_EDIT": "To edit",
      "CANCELED": "Canceled",
      "ARCHIVED": "Archived",
      "PUBLISHED": "Published",
      "DECLARED": "Declared",
      "FIRST_VALIDATION": "First validation",
      "SECOND_VALIDATION": "Second validation",
      "CONTRACT_MANAGEMENT": "In submission & management",
      "EVENT_IN_PROGRESS": "Event in progress",
      "EVENT_VALIDATING": "Validation expenses",
      "EVENT_IS_FINISHED": "Event finished"
    }
  }
}
